import { render, staticRenderFns } from "./InfrastructureTable.vue?vue&type=template&id=2bfdbcf1&"
import script from "./InfrastructureTable.vue?vue&type=script&lang=js&"
export * from "./InfrastructureTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports